var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hello_analytics") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,4.5A1.5,1.5,0,0,0,18.5,6a1.53,1.53,0,0,0,.33.93l-3.51,5.61a1.12,1.12,0,0,0-.32,0,1.5,1.5,0,0,0-1,.42l-3.48-1.74a1.1,1.1,0,0,0,0-.18,1.5,1.5,0,1,0-2.73.86l-3.36,4.7A1.84,1.84,0,0,0,4,16.5a1.5,1.5,0,1,0,1.23.64l3.36-4.7A1.84,1.84,0,0,0,9,12.5a1.5,1.5,0,0,0,1-.42l3.48,1.74a1.1,1.1,0,0,0,0,.18,1.5,1.5,0,0,0,3,0,1.53,1.53,0,0,0-.33-.93l3.51-5.61a1.12,1.12,0,0,0,.32,0,1.5,1.5,0,0,0,0-3Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.c7520ac3.svg";
export { ForwardRef as ReactComponent };